import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  ContentHome,
  ContentMyLists,
  ContentSearch,
  ContentSearchAll,
  Login,
  Signup,
} from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
    ,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
    ,
  },
  {
    path: '/home',
    name: 'ContentHome',
    component: ContentHome,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mylists',
    name: 'ContentMyLists',
    component: ContentMyLists,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/search',
    name: 'ContentSearch',
    component: ContentSearch,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/searchall',
    name: 'ContentSearchAll',
    component: ContentSearchAll,
    meta: {
      requiresAuth: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const currentUser = Vue.prototype.$auth.currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if(requiresAuth && !currentUser) {
    to.path === '/login' ? next() : next({name: 'Login'})
  } else if(!requiresAuth && currentUser) {
    to.path === '/home' ? next() : next({name: 'ContentHome'})
  } else {
    next()
  }
})

export default router
